import { Hint } from "@/HOC";
import styles from "./LegendButton.module.scss";
import { FC } from "react";
import { ILegendButton } from "./LegendButton.props";
import cn from "classnames";

const LegendButton: FC<ILegendButton> = ({ hint = "", warning = false, className, children, ...props }) => {
	return (
		<button
			type="button"
			className={cn(styles.legendButton, className, {
				[styles.legendButtonWarning]: warning,
			})}
			{...props}
		>
			<Hint hint={hint} position="top">
				<>{children}</>
			</Hint>
		</button>
	);
};

export default LegendButton;
